import React from "react";

export default function TransferSuccess() {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        background: "linear-gradient(135deg, #1e3a5f 0%, #2e6da4 50%, #4a90d9 100%)",
      }}
    >
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="h-2 bg-gradient-to-r from-green-500 via-green-400 to-emerald-400" />
          <div className="px-8 py-10 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-5">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Request Submitted</h1>
            <p className="text-gray-500 text-sm leading-relaxed">
              Your transfer request has been submitted successfully.
              <br />
              We will contact you soon.
            </p>
          </div>
        </div>
        <p className="text-center text-xs text-blue-200 mt-6">
          American Academy &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}

